import { Button, DatePicker, Input, Select } from "antd";

import React, { useEffect, useState } from "react";
import "../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  GetPaymentModes,
  GetVendorUnpaidOrders,
  RegisterPayment,
} from "../API  Functions/PurchaseFunctions";
import { toast } from "react-toastify";
import moment from "moment";
import LoadingSpinner from "../components/Loading";
import i18next from "i18next";

const styles = {
  selectant: {
    border: "none",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999,
  },
  container: {
    // width: "500px",
    padding: "30px",
    borderRadius: "18px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontSize: "25px",
    fontWeight: "bold",
    textAlign: "left",
    // marginBottom: "10px",
    // marginTop: "5px",
  },
  cancelIcon: {
    cursor: "pointer",
  },
  description: {
    textAlign: "left",
    fontSize: "16px",
    color: "#272728",
    marginTop: "10px",
  },
  input: {
    width: "100%",
    height: "5vh",
    // padding: "12px",
    borderRadius: "5px",
    // border: "1px solid #CCCCCC",
    marginBottom: "4px",
    boxSizing: "border-box",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    width: "180px",
    height: "42px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    marginRight: "10px",
  },
  confirmButton: {
    backgroundColor: "primaryBlue",
    color: "#FFFFFF",
  },
  cancelButton: {
    backgroundColor: "#CCCCCC",
    color: "#000000",
  },
  note: {
    color: "primaryBlue",
    marginTop: "20px",
    textAlign: "left",
  },
};

const PurchasePayment = ({
  isOpen,
  onClose,
  bill_id,
  page,
  due_amount,
  Popup,
  totalAmount,
  billDiscountPer,
  billDiscountVal,
  totalVatVal,
  selectedPaymentTerm,
  vendor_id,
  onPaymentSuccess
}) => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector((state) => state?.login?.user?.result?.company_id);


  const { Option } = Select;

  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(t("select"));
  const [restricted, setrestricted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paymentMode, setPaymentMode] = useState([]);
  const [amount, setAmount] = useState("");
  const [paymentDate, setPaymentDate] = useState(null);
  const [amountError, setAmountError] = useState("");
  const [cashId, setCashId] = useState(null);
  const [bankId, setBankId] = useState(null);
  const [unpaidOrders, setUnpaidOrders] = useState([]);
  const [selectedOrderAmount, setSelectedOrderAmount] = useState(null);


  const totalBillAmount =
    totalAmount -
    ((billDiscountPer / 100) * totalAmount + parseFloat(billDiscountVal || 0)) +
    totalVatVal;

  const handleAmountChange = (e) => {
    const value = e.target.value;

    console.log("PAGEEEEEE", page);


    setAmountError("");

    if (value < 0) {
      setAmountError(t("Amount cannot be negative."));
    } else if (value > totalBillAmount) {
      console.log("totalBillAmount", totalBillAmount);
      setAmountError(
        t(`Amount cannot exceed the due amount of ${totalBillAmount}`)
      );
    } else if (value > selectedOrderAmount && page === "allVendors") {
      console.log("selectedOrderAmount", selectedOrderAmount);
      setAmountError(`${t("Amount cannot exceed the due amount of")} ${selectedOrderAmount}`);

      // setAmountError(`${t("Amount cannot exceed the due amount of")} ${selectedOrderAmount}`);
    }
    else {
      console.log("setAmount", value);
      setAmount(value);
    }
    if (
      value > due_amount &&
      !(selectedPaymentTerm === "Immediate Payment" || selectedPaymentTerm === "الدفع الفوري")
    ) {
      setAmountError(t(`Amount cannot exceed the due amount of ${due_amount}`));
    }
  };

  const handleDateChange = (date, dateString) => {
    setPaymentDate(dateString);
  };

  const handleSelectChange = (value) => {
    setSelectedPaymentMode(value);
  };


  const handleOrderChange = (value) => {
    // Find the selected order by its ID
    const selectedOrder = unpaidOrders.find((order) => order.order_id === value);

    // Update the amount field with the selected order's amount_due
    if (selectedOrder) {
      setAmount(selectedOrder.amount_due || "");
      setSelectedOrderAmount(selectedOrder?.amount_due);

    }

    // Set the selected order ID for payment processing
    setSelectedOrder(selectedOrder?.bill_id);
  };

  const fetchPaymentMethods = () => {
    GetPaymentModes(user_id)
      .then((result) => {
        if (Array.isArray(result?.data?.result?.journals)) {
          setPaymentMode(result.data.result.journals);

          // Set IDs for Cash and Bank
          const cashMode = result.data.result.journals.find(
            (item) => item.name === "Cash"
          );
          const bankMode = result.data.result.journals.find(
            (item) => item.name === "Bank"
          );

          if (cashMode) setCashId(cashMode.id);
          if (bankMode) setBankId(bankMode.id);
        } else {
          console.error(
            "Expected an array but got:",
            result?.data?.result?.journals
          );
          setPaymentMode([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching payment methods:", error);
        setPaymentMode([]);
      });
  };


  const fetchOrders = () => {
    GetVendorUnpaidOrders(company_id, vendor_id)
      .then((result) => {
        // console.log("AFFAFGAFAFA---->", result);

        if (Array.isArray(result?.data?.result?.response)) {
          setUnpaidOrders(result.data.result.response);


        } else {
          console.error(
            "Expected an array but got:",
            result?.data?.result?.response
          );
          setUnpaidOrders([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching payment methods:", error);
        setUnpaidOrders([]);
      });
  };

  useEffect(() => {
    if (user_id) {
      fetchPaymentMethods();
    }
    if (page === "allVendors" && vendor_id) {
      fetchOrders();
    }
  }, [user_id]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!paymentDate || !amount) {
      return;
    }

    // console.log("ORDER ID", bill_id);
    setrestricted(true);
    setLoading(true);

    // console.log("selectedOrder", selectedOrder);


    const payload = {
      // bill_id: bill_id,

      ...(page === "createOrder" && { order_id: bill_id }),
      ...(page === "allVendors" && { bill_id: selectedOrder }),
      ...(page != "createOrder" && page != "allVendors" && { bill_id: bill_id }),

      paid_amount: Number(amount),
      payment_date: paymentDate,
      journal_id: selectedPaymentMode,
      vendor_id: Number(vendor_id),
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
    };
    console.log("PAYLOAD", payload);

    RegisterPayment(payload).then((response) => {
      // console.log("AAAAAAA", response);

      if (response?.status === "Payment Registered") {
        if (onPaymentSuccess) {
          onPaymentSuccess();
        }
        toast.success(t("Payment registered Successfully"));
        setAmount("");
        setAmountError("");
        setLoading(false);
        Popup();
      }
    });

    onClose();
  };


  useEffect(() => {
    if (
      totalBillAmount &&
      (selectedPaymentTerm === "Immediate Payment" ||
        selectedPaymentTerm === "الدفع الفوري")
    ) {
      setAmount(totalBillAmount);
      setAmountError("");
    } else if (due_amount) {
      setAmount(due_amount);
      setAmountError("");
    }
  }, [totalBillAmount, selectedPaymentTerm, due_amount]);

  return (
    <>
      {loading && <LoadingSpinner />}

      {isOpen && (
        <>
          <div style={styles.overlay} onClick={onClose}></div>
          <div style={styles.container} className="w-full md:w-[50%]">
            <div style={styles.header}>
              <p style={styles.title}>{t("Add Payment")}</p>
            </div>

            <div className="justify-content-center align-items-center">
              <form onSubmit={handleSubmit}>
                {page === "allVendors" && (
                  <>
                    <p className=" mb-2 mt-2">{t("Select Order")}</p>
                    <Select
                      showSearch  // Enable search functionality
                      style={styles.input}
                      placeholder={t("select")}
                      value={setSelectedOrder.order_number}
                      onChange={handleOrderChange}
                      filterOption={(input, option) => {
                        // Ensure option.children is a string
                        const children = option?.children?.toString()?.toLowerCase() || ''; // Convert to string if not already
                        return children.includes(input.toLowerCase());
                      }}
                    >
                      <Option value="select" disabled>
                        {t("select")}
                      </Option>
                      {unpaidOrders.map((item) => (
                        <Option key={item.order_id} value={item.order_id}>
                          {t(item.order_number)} ({`EGP ${item.amount_due}`})
                        </Option>
                      ))}
                    </Select>
                  </>
                )}

                {/* Date Selection Field */}
                <p className="mb-2 mt-2 ">{t("Payment Date")}</p>
                <DatePicker
                  style={styles.input}
                  onChange={handleDateChange}
                  placeholder={t("Select Payment Date")}
                  disabledDate={(current) =>
                    current && current > moment().endOf("day")
                  } // Disable future dates
                />

                {/* Amount Input Field */}
                <p className="mb-2 mt-2 ">{t("amount")}</p>
                <Input
                  style={styles.input}
                  value={amount}
                  onChange={handleAmountChange}
                  placeholder={t("Enter Amount")}
                  type="number"
                  step="0.01"
                  disabled={
                    totalBillAmount &&
                    (selectedPaymentTerm === "Immediate Payment" ||
                      selectedPaymentTerm === "الدفع الفوري")
                  }
                  min={0}
                  maxLength={7}
                />
                {amountError && (
                  <p className="text-red text-xs mb-4">{amountError}</p>
                )}
                <p className=" mb-2 mt-2">{t("Payment Mode")}</p>
                <Select
                  style={styles.input}
                  placeholder={t("select")}
                  // value={selectedPaymentMode.name}
                  value={selectedPaymentMode} // ✅ just use the ID
                  onChange={handleSelectChange}
                >
                  {/* <Option value="select" disabled>
                    {t("select")}
                  </Option> */}
                  {paymentMode.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {t(item.name)}
                    </Option>
                  ))}
                </Select>
                <div className="flex flex-row items-center justify-center mb-4"></div>

                <div className="flex justify-center mt-5">
                  <button
                    className="w-52 h-10 border-primaryBlue border text-primaryBlue text-sm font-semibold rounded-lg me-5"
                    onClick={onClose}
                  >
                    {t("close")}
                  </button>
                  <button
                    type="submit"
                    className={`w-52 h-10 ${paymentDate &&
                      amount && !amountError
                      && selectedPaymentMode !== null
                      ? "bg-primaryBlue"
                      : "bg-primaryBluedisabled"
                      } text-white text-sm font-semibold rounded-lg `}
                    disabled={
                      !paymentDate ||
                      // restricted ||
                      amountError ||
                      !amount ||
                      selectedPaymentMode === null}
                  >
                    {t("Done")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PurchasePayment;
